import { render, staticRenderFns } from "./RecipientField.vue?vue&type=template&id=14973b65"
import script from "./RecipientField.vue?vue&type=script&lang=js"
export * from "./RecipientField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports